import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  targetUserIdSelector,
  loggedUserIdSelector,
} from '../redux/context/selectors';

const useIsLoggedInUser = () => {
  const targetUserId = useSelector(targetUserIdSelector);

  const loggedInUserId = useSelector(loggedUserIdSelector);

  return useMemo(() => targetUserId === loggedInUserId, [
    targetUserId,
    loggedInUserId,
  ]);
};

export default useIsLoggedInUser;



// WEBPACK FOOTER //
// ./src/hooks/useIsLoggedInUser.js